<template>
  <div class="page-wrapper">
    <search-list @findData="findData" class="mb16"></search-list>

    <table-list
      title="" :columns="columns" :data="dataTable"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage"
    ></table-list>
    <img-show :src="imgSrc" :n="showImgKey"></img-show>
  </div>
</template>
<script>
  import SearchList from './components/SearchList'
  import TableList from "components/TableList/index";
  import {formatDateTime} from '@/utils/format'
  import {searchProjectList} from "../../../api/projectSearch";
  import ImgShow from 'components/ImgShow/index'
  export default {
    name: "project",
    components:{
      SearchList,
      TableList,
      ImgShow
    },

    data(){
      return {
        showImgKey:0,
        imgSrc:'',
        page:1,
        current: 1,
        total: 0,
        dataTable: [],
        loading: false,
        columns:[
          {
            type:'index',
            width:60,
          },

          {
            title:'项目名称',
            key:'project_name',
            align:'center',
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    let query = {

                    };
                    this.$router.push({
                      name: 'searchProjectDetail',
                      query: {projectFid: params.row['project_id']}
                    })  //
                  }
                }
              }, params.row['project_name'])
            }
          },{
            title:'项目头图',
            key:'project_pic',
            align:'center',
            render:(h,params)=>{

              return h('div',[
                h('Img',{
                  attrs:{
                    src: params.row['project_pic'],
                  },
                  style:{
                    width: '80px',
                    height: '45px',
                    margin:'5px',
                    cursor:'pointer'
                  },
                  on:{
                    click:()=>{
                      this.showImg(params.row['project_pic']);
                    }
                  }
                })
              ])
            }

          },
          {
            title:'项目状态',
            key:'projectStatusName',
            align:'center'

          },
          {
            title:'房型数',
            key:'house_type_room_nums',
            align:'center'
          },{
            title:'可出租房间数',
            key:'can_rent_count',
            align:'center'
          },{
            title:'最小价格(￥/月)',
            key:'min_price',
            align:'center'
          },{
            title:'最大价格(￥/月)',
            key:'max_price',
            align:'center'
          },{
            title:'项目地址',
            key:'project_address',
            align:'center'
          },{
            title:'房间状态',
            key:'house_type_status_name',
            align:'center'
          },{
            title:'商圈',
            key:'bizcircle_name',
            align:'center'
          },{
            title:'地铁',
            key:'subway_station',
            align:'center'
          }

        ],
        searched:null,
      }

    },
    methods:{
      findData(data){
        this.page=1;
        this.current=1;
        this.projectList(data)
      },
      projectList(data){
        let params={
          ...data,
          page:this.page,
          limit:10
        };
        searchProjectList(params).then(res=>{
          if(!res.data){
            return
          }
          this.dataTable=res.data.rows;
          this.total=res.data.total;
          this.searched=params
        }).catch(error=>{})
      },

      changePage(n){
        this.current = n;
        this.page = n;
        this.projectList(this.searched)

      },
      showImg(data) {
        this.imgSrc = data
        this.showImgKey++
      },

    }
  }
</script>

<style scoped>

</style>
